import React from 'react';
import '../styles/footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
        <a href="/terms-of-service" className="footer-link">Terms of Service</a>
        <a href="/cookie-policy" className="footer-link">Cookie Policy</a>
        <a href="/content-moderation-policy" className="footer-link">Content Moderation Policy</a>
      </div>
      <div className="footer-copyright">
        © {new Date().getFullYear()} Curios.dog. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
